import {
    FilterData,
    FilterBlockTypesEnum,
} from "../../src/apis/stateful-content";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const response: FilterData = {
    filterBlocks: [
        {
            type: FilterBlockTypesEnum.Select,
            name: "filter1",
            multiple: true,
            options: [
                {
                    value: "filter1_1",
                },
                {
                    value: "filter1_2",
                },
                {
                    value: "filter1_3",
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Select,
            name: "filter2",
            multiple: true,
            options: [
                {
                    value: "filter2_1",
                },
                {
                    value: "filter2_2",
                },
                {
                    value: "filter2_3",
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Dropdown,
            name: "location",
            filterable: true,
            filterItems: [
                {
                    value: "germany",
                },
                {
                    value: "uk",
                },
                {
                    value: "usa",
                },
                {
                    value: "france",
                },
                {
                    value: "spain",
                },
            ],
        },
    ],
};

const writeToFile = (object: FilterData, name: string) => {
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response, "ecat-modal-step1-filter");
